import CHART_TYPES from '../../charts'
import Partners from '../../../../crm/enums/partner-enum'
import moment from 'moment'

export default {
  reportingSocialOverview: {
    charts: [
      {
        type: CHART_TYPES.CARD,
        name: 'TotalGmbLocationsCreated',
        title: 'GMB Locations'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'TotalGmbLocationVerificationsCompleted',
        title: 'Locations Completed'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'TotalGmbLocationVerificationsPending',
        title: 'Locations Pending'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'TotalGmbLocationVerificationsFailed',
        title: 'Locations Failed'
      },
      {
        type: CHART_TYPES.CARD,
        name: 'TotalGmbLocationVerificationsNotSet',
        title: 'Locations Not Set',
        tooltip: [
          'This happens when we get a NULL value back from Google for the verification state.',
          'Some verifications with NULL values end up successfully being completed'
        ]
      },
      {
        type: CHART_TYPES.CARD,
        name: 'TotalGmbLocationVerificationsUnknown',
        title: 'Locations Unknown',
        tooltip: 'This happens when Google sends us back a state that either is not documented or is not understood'
      },
      {
        title: 'GMB Locations by Brand',
        type: CHART_TYPES.PIE,
        name: 'GmbLocationsByBrand',
        className: 'grid-col-4',
        displayAsPie: true,
        showDataLabels: true
      },
      {
        title: 'Verification States',
        type: CHART_TYPES.PIE,
        name: 'GmbLocationVerificationsByState',
        className: 'grid-col-4',
        displayAsPie: true,
        showDataLabels: true
      },
      {
        title: 'GMB Verifications by Method',
        type: CHART_TYPES.STACKED,
        name: 'GmbLocationVerificationsByMethodAndState',
        valueName: 'Units',
        className: 'grid-col-4',
        chartType: 'bar',
        tooltipLabel: ''
      },
      {
        title: 'Google My Business Location Verifications',
        type: CHART_TYPES.TABLE,
        name: 'GmbLocationVerifications',
        tooltip: 'A record of all the verification requests for Google My Business locations submitted across Builder Brands'
      }
    ],
    route: '/financial-reports/social/overview',
    disableToday: false,
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id],
    defaultDateRange: {
      start: moment('10/01/2019', 'MM/DD/YYYY'),
      end: moment()
    },
    hideGroupBy: true
  }
}
